const MOBILE_CLIENT_IDS = [
  '5f47819899085edfd241d763', // iOS
  '5f47819899085edfd241d764' // Android
];

const getClientId = (clientIdentity) => (
  typeof clientIdentity === 'string' ? clientIdentity.trim().split(/\s+/)[0] : ''
);

const isMobileAppSso = (query = {}) => MOBILE_CLIENT_IDS.includes(getClientId(query.clientIdentity));

// Carry only app context, never callback tokens or unrelated query parameters.
const getMobileSsoQuery = (query = {}) => {
  if (!isMobileAppSso(query)) return {};

  const context = { clientIdentity: getClientId(query.clientIdentity) };

  if (typeof query.appVersion === 'string' && query.appVersion.trim()) {
    context.appVersion = query.appVersion;
  }

  return context;
};

export { getClientId, isMobileAppSso, getMobileSsoQuery };
